// Module
var code = "<svg width=\"10\" height=\"12\" viewBox=\"0 0 10 12\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M8.8366 7.60591C9.91382 6.80628 9.91382 5.19372 8.8366 4.39409L3.69208 0.575277C2.37239 -0.404339 0.5 0.537645 0.5 2.18119L0.5 9.81882C0.5 11.4624 2.37239 12.4043 3.69208 11.4247L8.8366 7.60591Z\"/> </svg> ";
// Exports
module.exports = code;